import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/about/aboutone.jpg';
import galleryImg2 from '../img/envision/about/banner-3-blog-it-trends.jpg'; // Import other images as well
import galleryImgs31 from '../img/envision/dropdown/new/minidat.jpg';
import galleryImg41 from '../img/envision/about/ESG.png';

const Aboutsustainablefirstsection = () => {


    return (
        <section >
            <br></br>
            <div className="container" >
                <div className="row" >
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(28, 29, 29)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                A Journey Towards Driving   <span style={{ color: 'rgb(11 130 153)' }}>Sustainable Change from within</span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Envision is on a mission. Accelerating Engineering and Technology Convergence. Along with our customers, associates and partners, we are steering towards a sustainable future by aligning with the United Nations Sustainability Goals. Our dedication extends to investing in renewable energy and moving towards net-zero. We are also dedicated to fostering associate engagement and were recognized as a 'Progressive Place to Work.' This year, Envision focusses on afforestation, full gender pay transparency, and community development and more. Read our Sustainability report to find out more.
                                </p>
                                <p style={{color:'rgb(14 131 154)'}}>Download to Read the Sustainability Report 2024</p>
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                                <a href="/path/to/sustainability-report.pdf" download>
                                    <button className="btn btn " style={{background:'#edcf39'}}>
                                        Download Now
                                    </button>
                                </a>
                            </div>

                            <br></br>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={galleryImg41}
                            alt="imghome"
                            className="imgbg-col"
                            style={{
                                maxWidth: '100%',
                                padding: '15px',
                                height: '95%',
                                borderRadius: '50px' // Add border radius here
                            }}
                        />
                    </div>



                </div>
            </div>
        </section>

    );
};

export default Aboutsustainablefirstsection;
